<template>
  <div 
  :style="{
    display: 'flex',
    flexDirection: singleLine ? 'row' : 'column',
    ...(spaceBetween && { justifyContent: 'space-between' }) 
  }">
    <div v-if="title" class="text-left title w-full whitespace-break-spaces">{{title}}<span :class="required ? 'text-red-100 text-sm' : 'text-dark-gray text-sm font-light'">{{hideLabel ? '' : required?'*':optional?'(optional)':''}}</span></div>
    <div v-if="type == 'file' && inputStyle=='detailed'" @dragover.prevent="showDrag = true"
    @dragenter.prevent @drop.prevent="handleInputFile($event)"
    class="relative border-2 border-dashed border-gray rounded-md w-full bg-light-gray p-4 cursor-pointer mb-1">
      <div v-if="showDrag" class="absolute left-0 top-0 w-full h-full flex items-center justify-center bg-light-gray text-dark-gray font-bold">
        Drop Here
      </div>
      <label ref="imgInput" class="flex flex-wrap justify-center gap-2">
        <font-awesome-icon icon="file-import" style="font-size: 3em" class="text-mid-gray"/>
        <div class="text-left">
          <div class="font-bold text-dark-gray">{{inputValue ? inputValue.name : 'Click to upload or drag and drop your file'}}</div>
          <div v-if="accept" class="text-sm text-mid-gray">Please ensure that you upload a <span class="font-bold">{{accept}}</span> file that is smaller than <span class="font-bold">10MB</span>.</div>
        </div>
        <input @input="handleInputFile($event)" type="file" :accept="accept || '*'" id="fileUpload">
      </label>
    </div>
    <div v-else-if="type == 'file' && inputStyle=='basic'" >
      <label class="file-arrow-up">
        <div class="w-16 w-max-18  bg-orange-100 text-white float-right border-[1px] border-orange-100 rounded-md p-[0.45em]"
          :class="{
            'grayscale cursor-not-allowed': disabled,
            'hover:bg-white hover:text-orange-100 cursor-pointer': !disabled
            }" >
          <div class="flex flex-wrap justify-center">{{ inputTitle ? inputTitle : inputValue ? inputValue.name : 'Select a file'}}</div>
          <input @input="handleInputFile($event)" type="file" :accept="accept || '*'" :disabled="disabled">
        </div>
      </label>
    </div>
    <div v-else class="input-box" :style="`width:${width};height:${height}`" :class="{ 
      'bg-grey-5 cursor-not-allowed': disabled, 
      'bg-white': !disabled, 
      'error': error && showValidation,
      'flex border border-gray rounded p-1 items-center': type != 'richtext'
    }">
      <span v-if="currency" class="border-r border-gray pr-1 mr-1">{{CURRENCY_SYMBOL}}</span>
      <label ref="imgInput" v-if="type == 'file'" class="file-arrow-up">
        <div class="l-t-a gray-t-c">{{inputValue ? inputValue.name : 'Select a file'}}</div>
        <div class="hover:bg-orange-100 hover:text-white float-right border-[1px] border-orange-100 rounded-md p-[0.45em] text-orange-100 cursor-pointer">
          <input @input="handleInputFile($event)" type="file" :accept="accept || '*'">
          <span>Upload a file</span>
        </div>
      </label>
      <textarea v-else-if="type == 'textarea'" v-model="inputValue" 
       @input="handleInput"
       :min="min"
       :max="max"
       :maxlength="max"
       :placeholder="placeHolder" 
       :disabled="disabled"
       :rows="rows || '2'"
       class="input l-t-s" :class="{'cursor-not-allowed': disabled, 'resize-y': resize, 'resize-none': !resize }"/>
      <input v-else :type="type" v-model="inputValue"
       @input="handleInput"
       @click="inputClicked($event)"
       :min="min"
       :max="max"
       :maxlength="max"
       :placeholder="placeHolder"
       :disabled="disabled"
       class="input l-t-s" :class="{'cursor-not-allowed': disabled, 'no-arrows': noArrows }"/>
       <span v-if="percentage" class="border-l border-gray pl-1 lr-1">%</span>
       <span v-if="units" class="border-l h-full border-gray pl-1 pr-0.5">{{ units }}</span>
      <div class="flex gray-t-c" :class="type=='textarea'?'items-start':'items-center'">
        <div v-if="inputCounter && max" class="m-t-s gray-t-c">{{inputValue ? inputValue.length : 0}}/{{max}}</div>
        <div v-if="clearable && inputValue" @click="clearInput" class="cursor-pointer pl-1" >✖</div>
      </div>
    </div>
    <div v-if="error && showValidation" class="text-xs text-red-110 text-left">{{customError||error}}</div>
  </div>
</template>

<script>

export default {
  name: "inputBox",
  props: [
    'value',
    'type',
    'clearable',
    'title',
    'placeHolder',
    'singleLine',
    "min",
    "max",
    "inputCounter",
    "accept",
    "customError",
    "width",
    "height",
    "resize",
    "disabled",
    "optional",
    "required",
    "rows", //number of rows for textarea
    "integer",// don't allow dismal 
    "autoHighlight", // highlight the input text on click
    "currency",
    "percentage",
    "units",
    "inputStyle", //[basic, detailed]
    "inputTitle",
    "noArrows",
    "invalidRegex",
    "validator",
    "spaceBetween",
    "errorParams",
    "triggerValidation",
    "hideLabel", // To hide the required or optional tags,
  ],
  data() {
    return {
      inputValue: this.value,
      showDrag: false,

      regex: this.invalidRegex ? new RegExp(this.invalidRegex) : null,
      customToolbar: [
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link"],
      ],
      error: null,
      showValidation: true, // To be accessed by parent component through ref
    }
  },
  computed: {
    // error(){
    //   console.log('computed validation')
    //   const val = this.type == 'number' ? parseFloat(this.inputValue) : this.inputValue
    //   if(this.min && val < this.min){
    //     return `Value must be more than ${this.min}`
    //   }
    //   if(this.max && val > this.max){
    //     console.log(`🚨 → error → this.inputValue > this.max:`, this.inputValue , this.max)
    //     return `Value must be less than ${this.max}`
    //   }
    //   if(this.validator) {
    //     for (const [message, func] of Object.entries(this.validator)) {
    //       if(func(val) == true) {
    //         this.$emit('error', {msg: message, field: this.$vnode.key })
    //         return message;
    //         break;
    //       };
    //     }
    //   }
    //   this.$emit('error', {msg: null, field: this.$vnode.key }) 
    //   return null
    // }
  },
  methods:{
    handleInput (e) {
      if(this.inputValue === '') this.inputValue = null;
      if(this.integer && this.type == "number" && this.inputValue){
        this.inputValue = parseInt(this.inputValue)
      }
      this.$emit('input', this.inputValue)
      this.validate();
    },
    handleInputFile (e) {
      console.log(`🚨 → handleInputFile → e:`, e)
      this.showDrag = false
      this.inputValue = e?.target?.files?.[0] || e?.dataTransfer?.files?.[0]
      this.$emit('input',this.inputValue)
    },
    clearInput(){
      this.inputValue = null
      if(this.type == 'file') document.getElementById('fileUpload').value = null;
      this.$emit('input', this.inputValue);
      this.validate();
    },
    selectFile(){
      this.$refs.imgInput?.click()
    },
    inputClicked(e){
      if(this.autoHighlight){
        e.srcElement.select()
      }
    },
    validate() {
      const val = this.inputValue == null ? null : this.type == 'number' ? parseFloat(this.inputValue) : this.inputValue
      const getMessage = (val) => {
        if(this.optional && val == null || isNaN(val)) {
          return null;
        }
        if((this.min || this.min === 0) && val < this.min){
          return `Value must be ${this.min} or more`
        }
        if(this.max && val > this.max){
          return `Value must be less than ${this.max}`
        }
        if(this.type == 'number' && isNaN(val)) {
          return `Value must be a number`
        }
        if(this.validator) {
          for (const [message, func] of Object.entries(this.validator)) {
            if(func(val) == true) {
              return message;
              break;
            };
          }
        }
        return null
      }
      this.error = getMessage(val)
      this.$emit('error', { msg: this.error, ...this.errorParams})
    }
  },
  watch:{
    value(newVal, oldVal){
      if (newVal != this.inputValue) {
        this.inputValue = newVal
        this.validate();
      }
      if(this.regex && this.regex.test(newVal)) {
        this.inputValue = oldVal
        this.$emit('input', this.inputValue)
      }
    },
    triggerValidation(val) {
      this.validate();
    },
    inputValue(newVal, oldVal) {
    },
  },
  created() {
    this.validate() 
  },
  destroyed() {
    this.$emit('error', { msg: null, ...this.errorParams})
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  opacity: 1;
}
.textarea {
  resize: none;
}
.input-box{
  width: 100%;
}
.input-box > .quillWrapper > .ql-toolbar {
  @apply rounded-t 
}
.input-box > .quillWrapper > .ql-container {
  @apply rounded-b
}
.title{
  margin-right: .5em;
}
.input{
  width: 100%;
  padding: 0;
  margin: 0;
  outline: none;
  border: none;
}
.side-box{
  display: flex;
  align-items: center;
}
.side-box>*{
  margin-left: .5em;
  width: max-content;
}
input[type="file"] {
    display: none;
}
.file-arrow-up{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Hide arrows in Webkit browsers (Chrome, Safari, Edge) */
.no-arrows::-webkit-outer-spin-button,
.no-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows in Firefox */
.no-arrows {
  -moz-appearance: textfield;
}

.error {
  @apply border border-red-100
}
</style>